<template>
  <v-app>
    <div class="d-flex">
      <side_nav v-if="!this.$route.path.includes('login')"></side_nav>
      <v-main>
        <router-view></router-view>
      </v-main>
    </div>

    <snackbar></snackbar>
    <progressBar></progressBar>
  </v-app>
</template>

<script>
import snackbar from "./components/snackbar.vue";
import progressBar from "./components/progressBar.vue";
import side_nav from "./components/side_nav.vue";

export default {
  name: "App",

  components: {
    snackbar,
    progressBar,
    side_nav,
  },

  beforeMount(){
      window.scrollTo(0, 0);
      // no token redirect
      this.token = localStorage.getItem("token") || sessionStorage.getItem("token");
      if (this.token === undefined || this.token === null) {
        console.log("auth");
        this.$router.push("/login").catch(() => {});
      }
  },

  data: () => ({
    token: "",
  }),
};
</script>


<style>
@font-face {
  font-family: samim;
  src: url(./assets/fonts/samim/Farsi-Digits-Without-Latin/Samim-FD-WOL.ttf);
}

html {
  font-family: samim !important;
  position: relative;
}
.v-application .v-application--wrap * {
  font-family: samim !important;
}
.v-dialog,
.v-dialog .text-caption,
.text-subtitle-2 , .v-dialog .caption {
  font-family: samim !important;
}
.v-selection-control {
  display: block !important;
}
.toasted {
  direction: rtl;
  font-family: samim !important;
  font-size: 12px !important;
}
.v-list-item__title{
  font-family: samim !important;

}

/* remove number input arrows */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
